import { Observable, Subject } from "rxjs";

import { AbstractConstructor, Constructor } from "../models";
import { OnDestroy } from "@angular/core";

export interface HasDestroyed extends OnDestroy {
  readonly destroyed: Observable<void>;
}

export type HasDestroyedCtor = Constructor<HasDestroyed> & AbstractConstructor<HasDestroyed>;

export function mixinHasDestroyed<T extends Constructor | AbstractConstructor>(base:T) : T & HasDestroyedCtor {

  return class extends base implements OnDestroy {

    private readonly _destroyed = new Subject<void>();
    public readonly destroyed = this._destroyed.asObservable();

    ngOnDestroy(): void {
      this._destroyed.next();
      this._destroyed.complete();
    }
  }
}
